import debug from 'debug'
import { useCallback, useRef, useState } from 'react'
import { useImpressionUnavailable } from '../../../../../__helpers/impression-unavailable-helper'
import { pnArticleStickyVideoClassName } from '../PNArticleVideo.styled'

const stickyVideoDebug = debug('pn:sticky-video')
const percentageVideoUnviewableBeforeSticky = 50

export interface StickyVideoProps {
    userInteracted: boolean
}

export const useStickyVideo = ({ userInteracted }: StickyVideoProps) => {
    const [isCurrentlySticky, setIsCurrentlySticky] = useState(false)
    const stickyRef = useRef<HTMLDivElement | null>(null)

    const stateChangeHandler = useCallback(
        (available: boolean) => {
            // If the user hasn't interacted with the video, don't do anything
            if (!userInteracted) return

            // Now handle accordingly
            if (available) {
                stickyRef.current?.classList.add(pnArticleStickyVideoClassName)
                setIsCurrentlySticky(true)
            } else {
                stickyRef.current?.classList.remove(
                    pnArticleStickyVideoClassName,
                )
                setIsCurrentlySticky(false)
            }
        },
        [userInteracted, stickyRef],
    )

    // Using react callbacks to ensure these functions are not re-created on each render
    const availableHandler = useCallback(
        () => stateChangeHandler(false),
        [stateChangeHandler],
    )
    const unavailableHandler = useCallback(
        () => stateChangeHandler(true),
        [stateChangeHandler],
    )

    const impressionUnavailableRef = useImpressionUnavailable({
        unavailable: unavailableHandler,
        available: availableHandler,
        percentageUnviewable: percentageVideoUnviewableBeforeSticky,
        debug: stickyVideoDebug,
    })

    return {
        isCurrentlySticky,
        impressionUnavailableRef,
        stickyRef,
    }
}
